import { LazyLoad } from 'app/utils';

export const StatementFormPage = LazyLoad(
  () => import('./index'),
  (module) => module.StatementFormPage,
);
